
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faBell, faLightbulb, faPenNib, faSignInAlt, faUserPlus, faAt, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from 'react-responsive';
import { Spinner } from 'react-bootstrap';
import { BASE_URL } from '../App';
import fingerprintSuccess from '../Finger print Lock - success.json'; // تأكد إن المسار صحيح
import formColor from '../Note Paper Color.json'; // تأكد إن المسار صحيح
import formLight from '../Note Paper.json'; // تأكد إن المسار صحيح
import Lottie from 'lottie-react';
import DarkModeToggle from './DarkModeToggle';

function AppNavbar ({loggedIn  , auth  , clearToken , isDarkMode, toggleDarkMode , style} ) {
  
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [isProfileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [isBellDropdownOpen, setBellDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  const isMobileDevice = useMediaQuery({ query: '(max-width: 767px)' });

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
      setScrollTop((window.scrollY / (document.documentElement.scrollHeight - document.documentElement.clientHeight)) * 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // useEffect(() => {
  //   const fetchNotifications = async () => {
  //     try {
  //       const token = localStorage.getItem('token');
  //       const config = {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           "ngrok-skip-browser-warning": "any",
  //           'Authorization': `Bearer ${token}`,
  //         }
  //       };
  //       const response = await axios.get(`${BASE_URL}/api/mynotifications`, config);
  //       setNotifications(response.data.data);
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchNotifications();
  // }, []);

 

  const handleMenuToggle = () => setMenuOpen(prev => !prev);
  const toggleProfileDropdown = () => setProfileDropdownOpen(prev => !prev);
  const toggleBellDropdown = () => setBellDropdownOpen(prev => !prev);

  const handleProfileOutsideClick = (event) => {
    if (!event.target.closest('.user_img')) {
      setProfileDropdownOpen(false);
    }
  };

  const handleBellOutsideClick = (event) => {
    if (!event.target.closest('.bell')) {
      setBellDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (isProfileDropdownOpen) {
      document.addEventListener('click', handleProfileOutsideClick);
    } else {
      document.removeEventListener('click', handleProfileOutsideClick);
    }

    if (isBellDropdownOpen) {
      document.addEventListener('click', handleBellOutsideClick);
    } else {
      document.removeEventListener('click', handleBellOutsideClick);
    }

    return () => {
      document.removeEventListener('click', handleProfileOutsideClick);
      document.removeEventListener('click', handleBellOutsideClick);
    };
  }, [isProfileDropdownOpen, isBellDropdownOpen]);

    return (   
      <>

      <nav
      className={` nav-bar ${isSticky ? 'sticky' : ''} ${isMenuOpen ? 'open' : ''}   ${style ? 'dark-mode' : ''}`} >
 
     <div className="container">
   
      {
        loggedIn ?
        ""
        :
        <div className={`menu-toggle ${isMenuOpen ? 'open' : ''}`} onClick={handleMenuToggle}>
        <span className="bar"></span>
  <span className="bar"></span>
  <span className="bar"></span>
</div>
      }

<div className='d-flex align-items-center mobile-layout'>
  {/* {
    loggedIn
    ?
    <div className='wallet-mobile'>
      <Link to={`/charge-wallet`}>
      <img src='/images/wallet.png' alt='' loading='lazy'/>
      </Link>

    </div>
    :
    ''
  } */}
<div className="dark-mode-toggle-ink" onClick={toggleDarkMode}>
<DarkModeToggle isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />

    </div>
      <Link to="/" className="logo">
        <img className='dark-logo' src='/images/logo-light.png' loading='lazy' alt=""/>
        <img className='light-logo'  src='/images/logo-dark.png' loading='lazy' alt=''/>
   
      </Link>
    </div>
      
      <ul className={`${isMenuOpen ? 'show' : ''}`}>
          {
            loggedIn ?
            <>
          
          <div className='bell-img'>
           {/* User Profile Dropdown */}
      <img
        src={"/images/man.png"}
        alt=""
        className="user_img"
        loading="lazy"
        onClick={toggleProfileDropdown}
      />
      {isProfileDropdownOpen && (
        <div className={`drop ${isProfileDropdownOpen ? 'show' : ''}`}>
          <Link>
            <span className='me-2' style={{ whiteSpace: 'nowrap' }}>{auth.fname}</span> <span className='d-flex align-items-center flex-row-reverse'>  اهلاً <span className='me-1'>وسهلاً</span> </span>
          </Link>
          <Link to="/profile" onClick={() => setProfileDropdownOpen(false)}> حسابي <img src='/images/profile-removebg-preview..webp' loading="lazy" alt="" /></Link>
          <Link to="/profile/courses" onClick={() => setProfileDropdownOpen(false)}> كورساتي <img src='/images/profile-removebg-preview..webp' loading="lazy" alt="" /></Link>
          <Link onClick={clearToken}> تسجيل الخروج <img src='/images/logout-removebg-preview..webp' alt="" loading="lazy"/></Link>
        </div>
      )}


    <div className='wallet'>
      <Link to={`/charge-wallet`}>
      {/* <img src={style ? '/images/wallet1.svg' : '/images/wallet2.svg'} alt='' loading='lazy'/> */}
      <img src='/images/wallet.png' />
      </Link>

    </div>
            </div>  

            </>

            :
    
            <>
          <li>
          <Link to="/loginuser" className="login"> 
            <div className="btn-content">
              <FontAwesomeIcon icon={faAt} className="btn-icon" />
              <div className="btn-text">
                <span className="child-span">دخولك يلا</span>
                <span className={`first-span ${style ? 'dark-mode' : ''}`}>سجل</span>
              </div>
            </div>
            <div className="btn-glow"></div>
          </Link>
          </li>
          <li>  
          <Link to="/registeruser" className="register"> 
            <div className="btn-content">
              <FontAwesomeIcon icon={faUserPlus} className="btn-icon" />
              <div className="btn-text">
                <span>خش اعمل اكونت !</span>
              </div>
            </div>
            <div className="btn-glow"></div>
          </Link>
          </li>
          <li>  
          <Link to="/parent-login" className="parent-login"> 
            <div className="btn-content">
              <FontAwesomeIcon icon={faUsers} className="btn-icon" />
              <div className="btn-text">
                <span>ولي الأمر</span>
              </div>
            </div>
            <div className="btn-glow"></div>
          </Link>
          </li> 
            </>

          }
      </ul>
     </div>
     
     <div className={`scroller ${isSticky ? 'sticky' : ''} ${style ? 'dark-mode' : ''}`}>
    <div
      className={`scrollerStyle ${isDarkMode ? 'dark-mode' : ''}`}
      style={{ width: `${scrollTop}%` }}
    ></div>
      </div>
   
    </nav>
      </>
    
    )
}



export default AppNavbar;







